// extracted by mini-css-extract-plugin
export var section = "become_a_xeal_partner-module--section--079ee";